module.exports = __webpack_public_path__ + "img/serial_number.e82bb140.png";